module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper main-container"
  }, [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isSubmitSettingsLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Announcement")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', [_c('vue-editor', {
    attrs: {
      "editorToolbar": _vm.customEditorToolbar
    },
    model: {
      value: (_vm.announcementHTML),
      callback: function($$v) {
        _vm.announcementHTML = $$v
      },
      expression: "announcementHTML"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "ml",
    domProps: {
      "innerHTML": _vm._s(_vm.announcementHTMLWithSafeLinks)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg mt",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.handleSubmitSettings
    }
  }, [_vm._v("Submit")])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Settings\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4b1c7c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminSettings.vue
// module id = 2211
// module chunks = 1